<template>
   <div class="content">
    <h1>甘肃信息惠民服务热线接线统计</h1>
    <h2>{{time}}</h2>
    <div class="charts" id="main"></div>
  </div>
</template>

<script>
export default {
  name: 'serviceCharts2',
  methods: {
    drawLine () {
      let vm = this
      let myChart = vm.$echarts.init(document.getElementById('main'))
      let option = {
        title: {
          // text: '2018年9月20日当日接线统计',
          // subtext: '总计668件'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#283b56'
            }
          }
        },

        legend: {
          data: ['当日', '总计']
        },
        /* toolbox: {
          show: true,
          feature: {
            dataView: {readOnly: false},
            restore: {},
            saveAsImage: {}
          }
        }, */
        dataZoom: {
          show: false,
          start: 0,
          end: 200
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: true,
			axisLabel: {
				fontWeight: 'bold',
				fontSize: 16
			},
            data: (function () {
              var now = new Date()
              var res = []
			  var len = now.getHours();
              while (len--) {
                res.unshift(now.getHours() + '时')
                now = new Date(now - 3600*1000)
              }
			  res.unshift('0时')
              return res
            })()
          }
        ],
        yAxis: [
          {
            type: 'value',
            scale: true,
            name: '接线量',
            //max: 50,
            min: 0,
			//interval: 5,
            boundaryGap: [0.2, 0.2]
          }
        ],
        series: [
          {
            type: 'bar',
            name: '接线数',
            itemStyle: {
              normal: {
                color: function (params) {
                  // 首先定义一个数组
                  var colorList = [
                    '#F47A25', '#EFE42A', '#64BD3D', '#EE9201', '#29AAE3',
                    '#B74AE5', '#0AAF9F', '#E89589', '#60C0EB', '#5472EC', '#F37126', '#FDB01F', '#4498FA', '#8B55FD', '#B72DFF', '#0BE0A6', '#7BCE4C'
                  ]
                  return colorList[params.dataIndex]
                },
                // 以下为是否显示
                label: {
                  show: true,
				  position: 'top'
                }
              }
            },

            data: (function () {
              var res = []
              var len = new Date().getHours();
              while (len--) {
				if (len < 7) {
					res.unshift(Math.round(Math.random() * 1).toFixed(0))
				} else if ((len > 7 && len < 10) || (len > 11 && len < 15) || (len > 16 && len < 20)) {
					res.unshift(Math.round(Math.random() * 30).toFixed(0) - 0 + 20)
				} else {
					res.unshift(Math.round(Math.random() * 20).toFixed(0))
				}
                //res.push(Math.round(Math.random() * 50))
              }
			  res.push((Math.random()*2).toFixed(0) - 0)
              return res
            })()
          }
        ]
      }
      myChart.setOption(option)
      let count = 11
      setInterval(function () {
		let len = option.xAxis[0].data.length;
		let lastTime = option.xAxis[0].data[len - 1];
        let axisData = (new Date()).getHours() + '时'
		if (lastTime !== axisData) {
			//option.xAxis[0].data.shift()
			option.xAxis[0].data.push(axisData)
			
			let data0 = option.series[0].data
			//data0.shift()
			data0.push(0)
		} else {
			let data0 = option.series[0].data
			for (let i = 0; i < len; i++) {
				var n = data0[i]
				if (i === len - 1) {
					data0[i] = n + ((Math.random() * 1).toFixed(0) - 0)
				} else {
					data0[i] = n
				}
			}
			//option.series[0].data[len - 1] = lastData0 + (lastData0 > 40 ? 0 : ((Math.random() * 1).toFixed(0) - 0))
		}

        myChart.setOption(option)
      }, 10000)
    }
  },
  mounted () {
    let vm = this
    vm.drawLine()
  },
  computed: {
    time: function () {
      var myDate = new Date()
      let month = Number(myDate.getMonth()) + 1
      return myDate.getFullYear() + '年' + month + '月' + myDate.getDate() + '日'
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
 html,body,.content,.charts {
   width: 100%;
   height: 100%;
 }
 .charts {
   padding-top: 300px;
    height: 900px;
 }
 h1 {
   width: 100%;
   color: #0034E4;
   text-align: center;
   font-size: 40px;
   position: absolute;
   top: 0;
   left: 0;
   line-height: 100px;
   margin-top: 80px;
 }
  h2 {
   width: 100%;
   color: #0034E4;
   text-align: center;
   font-size: 40px;
   position: absolute;
   top: 100px;
   left: 0;
   line-height: 100px;
   margin-top: 50px;
 }
</style>
